/// <reference types="vite/client" />
import { useLangStore, type Lang } from "./langStore";

// Los diccionarios se componen a partir de fragmentos por área
// (`locales/es/*.ts` y `locales/en/*.ts`), cada uno `export default { ns: {...} }`.
// Vite los une con import.meta.glob → añadir una página nueva NO toca este índice
// ni provoca conflictos (clave para paralelizar la traducción).
const esModules = import.meta.glob("./locales/es/*.ts", { eager: true });
const enModules = import.meta.glob("./locales/en/*.ts", { eager: true });

function merge(modules: Record<string, unknown>): Record<string, unknown> {
  return Object.assign({}, ...Object.values(modules).map((m) => (m as { default: unknown }).default));
}

const DICTS: Record<Lang, Record<string, unknown>> = {
  es: merge(esModules),
  en: merge(enModules),
};

function lookup(dict: Record<string, unknown>, key: string): unknown {
  return key.split(".").reduce<unknown>(
    (o, k) => (o == null ? o : (o as Record<string, unknown>)[k]),
    dict
  );
}

/** Traducción pura: `key` con puntos ("nav.dashboard"), interpolación `{var}`.
 *  Fallback: idioma actual → español → la propia clave. */
export function translate(lang: Lang, key: string, vars?: Record<string, string | number>): string {
  const raw = lookup(DICTS[lang], key) ?? lookup(DICTS.es, key);
  if (typeof raw !== "string") return key;
  let s = raw;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(String(v));
  }
  return s;
}

/** Hook: devuelve `t(key, vars?)` y re-renderiza al cambiar de idioma. */
export function useT() {
  const lang = useLangStore((s) => s.lang);
  return (key: string, vars?: Record<string, string | number>) => translate(lang, key, vars);
}

export function useLang(): Lang {
  return useLangStore((s) => s.lang);
}
